import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JobTypePipe } from '@cfg-pipes/job-type/job-type.pipe';
import { CarTypePipe } from '@cfg-pipes/car-type/car-type.pipe';
import { CarStatusPipe } from '@cfg-pipes/car-status/car-status.pipe';
import { MessagesListComponent } from '../features/views/public/chats/components/messages-list/messages-list.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AlertModule } from 'ngx-bootstrap/alert';
import { RequestTypePipe } from '@cfg-pipes/request-type/request-type.pipe';
import { PhoneCompletionModalComponent } from './components/phone-completion-modal/phone-completion-modal.component';



@NgModule({
  declarations: [
    JobTypePipe,
    CarTypePipe,
    CarStatusPipe,
    RequestTypePipe,
    MessagesListComponent,
    PhoneCompletionModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    AlertModule.forRoot()
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    JobTypePipe,
    CarTypePipe,
    CarStatusPipe,
    RequestTypePipe,
    MessagesListComponent,
    PhoneCompletionModalComponent,
    BsDropdownModule,
  ]
})
export class SharedModule { }
